import { getNextApiRoute, typedFetch } from '@libs/common-next';
import { HttpMethod } from '@libs/core';

export const getUserHasActiveSubscriptions = async (
    email: string,
    sid: string
) => {
    const ogId = await typedFetch<{
        merchant_user_id: string;
    }>(getNextApiRoute(`auto-ship/order-groove/`), {
        method: HttpMethod.POST,
        body: JSON.stringify({
            email: email,
            customerId: sid,
        }),
        headers: {
            'content-type': 'application/json',
        },
    });

    if (ogId) {
        return await typedFetch<{
            hasAutoshipOrders: boolean | null;
        }>(
            getNextApiRoute(
                `auto-ship/subscriptions/${ogId?.merchant_user_id}`
            ),
            {
                method: HttpMethod.GET,
                headers: {
                    'content-type': 'application/json',
                },
            }
        );
    }

    return { hasAutoshipOrders: false };
};
